import { createStore } from 'redux';

export type TState = {
  token?: string;
  showMenus: boolean;
  triggerToolbox?: () => void;
  subappRouter: any;
  beforeLogout?: () => void;
};

type TAction = {
  type: string;
  payload: any;
};

const reducer = (
  state: TState = {
    showMenus: true,
    subappRouter: null
  },
  action: TAction
): TState => {
  switch (action.type) {
    default:
      return state;
    // 设置 Token
    case 'SET_TOKEN':
      return {
        ...state,
        token: action.payload
      };
    // 设置是否展示子应用顶部菜单栏
    case 'SET_SHOWMENUS':
      return {
        ...state,
        showMenus: action.payload
      };
    case 'SET_TOOLBOX_TRIGGER':
      return {
        ...state,
        triggerToolbox: action.payload
      };
    case 'SET_MENUROUTER':
      return {
        ...state,
        subappRouter: action.payload,
        showMenus: true
      };
    case 'SET_BEFORE_LOGOUT':
      return {
        ...state,
        beforeLogout: action.payload
      };
  }
};

const store = createStore<TState, TAction, unknown, unknown>(reducer);

export default store;
